import { Box } from "@mui/material"
import type { FC } from "react"
import { useMemo } from "react"

import { CheckedInPurchaseOrderLine } from "./CheckedInPurchaseOrderLine"

import type { GoodsReceiptPalletRow, GoodsReceiptProductDetail, Order } from "@/graphql/codegen/graphql"
import { GoodsReceiptDetailsSubtotals, GoodsReceiptPurchaseOrderPanel } from "@/screens/WarehouseReceiving/components"
import type { GoodsReceiptTotals } from "@/screens/WarehouseReceiving/types"
import { calculatePurchaseOrderTotalsFromPalletRows } from "@/screens/WarehouseReceiving/utils"

interface CheckedInPurchaseOrderProps {
  purchaseOrder: Order
  goodsReceiptLines: GoodsReceiptProductDetail[]
  goodsReceiptPalletRows: GoodsReceiptPalletRow[]
}

export const CheckedInPurchaseOrder: FC<CheckedInPurchaseOrderProps> = ({
  purchaseOrder,
  goodsReceiptLines,
  goodsReceiptPalletRows,
}) => {
  const totals: GoodsReceiptTotals = useMemo(() => {
    const lines = purchaseOrder.orderLines ?? []

    return calculatePurchaseOrderTotalsFromPalletRows(lines, goodsReceiptLines, goodsReceiptPalletRows)
  }, [purchaseOrder.orderLines, goodsReceiptLines, goodsReceiptPalletRows])

  return (
    <GoodsReceiptPurchaseOrderPanel
      key={purchaseOrder.orderId}
      purchaseOrder={purchaseOrder}
      totals={totals}
      hasEstimatedValues={false}
    >
      <Box className='flex flex-col gap-y-6'>
        {purchaseOrder.orderLines?.map((purchaseOrderLine) => (
          <CheckedInPurchaseOrderLine
            key={purchaseOrderLine.orderLineId}
            purchaseOrderLine={purchaseOrderLine}
            goodsReceiptLines={goodsReceiptLines}
            goodsReceiptPalletRows={goodsReceiptPalletRows}
          />
        ))}
        <GoodsReceiptDetailsSubtotals label='Subtotal Received' totals={totals} />
      </Box>
    </GoodsReceiptPurchaseOrderPanel>
  )
}
